function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.698 8.83c0 .48-.389.868-.868.868H1.885a.868.868 0 01-.868-.868V1.885c0-.479.389-.868.868-.868H8.83c.48 0 .868.389.868.868V8.83zm11.285 0c0 .48-.389.868-.868.868H13.17a.868.868 0 01-.868-.868V1.885c0-.479.389-.868.868-.868h6.945c.479 0 .868.389.868.868V8.83zM9.698 20.115a.868.868 0 01-.868.868H1.885a.868.868 0 01-.868-.868V13.17c0-.48.389-.868.868-.868H8.83c.48 0 .868.389.868.868v6.945zm11.285 0a.868.868 0 01-.868.868H13.17a.868.868 0 01-.868-.868V13.17c0-.48.389-.868.868-.868h6.945c.479 0 .868.389.868.868v6.945z",
  stroke: "#000",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22
  }, props), _ref);
}

export default SvgGrid;